<template>
	<div class="user-cell">
		<ProfilePic :user="user" size="40px" />
		<div class="user-data">
			<div class="user-data-info">
				<div class="name" v-text="name" />
				<Tag v-if="showTag" :primary="user.role === 'manager'">
					{{ $t(`model_role_${user.role.toLowerCase()}`) }}
				</Tag>
			</div>

			<div class="contact-info" v-if="!hideContact">
				<PrettyPhone :user="user" />
				<span v-if="user.phone && user.email" class="bullet-point"
					>&#8226;</span
				>
				<div class="email" v-text="user.email" />
			</div>
		</div>
	</div>
</template>

<script>
import { ProfilePic, Tag } from '@/components/common'
import PrettyPhone from './PrettyPhone'

export default {
	name: 'UserCell',
	components: { ProfilePic, Tag, PrettyPhone },
	props: {
		user: Object,
		hideTag: { type: Boolean, default: null },
		hideContact: { type: Boolean, default: null },
	},
	computed: {
		showTag() {
			return !this.hideTag && ['admin', 'manager'].includes(this.user.role)
		},
		name() {
			return this.user.fullname || this.$t('contacts_contactpicker_noname')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.user-cell {
	display: flex;
	align-items: center;

	:deep(.profile-pic-avatar) {
		margin-right: 8px;
	}

	.pronto-tag {
		margin-left: 8px;
	}

	.user-data-info {
		display: flex;
		align-items: center;
	}

	.contact-info {
		display: flex;
		align-items: center;
		font-family: Avenir;
		font-weight: normal;
		font-size: 14px;
		color: var(--neutral-600);

		.bullet-point {
			margin: 0 5px;
			color: #c7cace;
		}
	}
}
</style>
